import { useTranslate } from "@similarweb/i18n-provider";
import { Warning } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, CircularLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const ADS_MODAL_CONTENT_HEIGHT = "400px";

type AlertFallbackProps = {
    isError?: boolean;
    retry: () => void;
};

export const AlertFallback = ({ isError, retry }: AlertFallbackProps) => {
    const { translate } = useTranslate();

    if (isError) {
        return (
            <Stack
                height={ADS_MODAL_CONTENT_HEIGHT}
                width="100%"
                alignItems="center"
                justifyContent="center"
                gap="16px"
            >
                <Warning
                    width={48}
                    height={48}
                    color={colorsPalettes.carbon[250]}
                />
                <Button
                    type="flat"
                    onClick={retry}
                    dataAutomation="ads-alert-modal-retry"
                >
                    {translate("activation.alerts.feed.error.retry")}
                </Button>
            </Stack>
        );
    }

    return (
        <Flex
            height={ADS_MODAL_CONTENT_HEIGHT}
            width="100%"
            alignItems="center"
            justifyContent="center"
        >
            <CircularLoader isLarge />
        </Flex>
    );
};
